import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/companycard/getACardAccountPage',
        method: 'get',
        params: query
    })
}
export function getACardAccountCount(data) {
    return request({
        url: '/chain/companycard/getACardAccountCount',
        method: 'post',
        data
    })
}
